// eslint-disable-next-line no-restricted-imports
import {tokens, css} from '@sail/ui';

export const globalStyles = css.global({
  'html,body': {
    margin: 0,
  },

  body: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },

  '*': {
    boxSizing: 'border-box',
  },

  'h1,h2,h3,h4,h5,h6,p,blockquote,pre,figure': {
    margin: 0,
  },

  a: {
    textDecoration: 'none',
  },

  strong: {
    fontWeight: `${tokens.font.weight.bold}`,
  },
});
